export default function TrustSection() {
  const stats = [
    { number: "30+", label: "深度购票指南" },
    { number: "5", label: "正规购票渠道" },
    { number: "10万+", label: "累计阅读量" },
    { number: "100%", label: "官方信息源" },
  ];

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择我们？
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            我们致力于为中国球迷提供最全面、最可靠的世界杯门票购买信息
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-5">
              <div className="text-3xl md:text-4xl font-bold text-primary-500 mb-2">
                {stat.number}
              </div>
              <div className="text-sm text-foreground-600">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="p-5 bg-background-50 rounded-lg border border-background-200">
            <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg mb-3">
              <i className="ri-shield-check-line text-accent-500 text-lg"></i>
            </div>
            <h3 className="text-base font-semibold text-foreground-900 mb-2">信息可靠</h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              所有信息来源于FIFA官网及官方授权渠道，确保准确性和时效性
            </p>
          </div>
          <div className="p-5 bg-background-50 rounded-lg border border-background-200">
            <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg mb-3">
              <i className="ri-time-line text-accent-500 text-lg"></i>
            </div>
            <h3 className="text-base font-semibold text-foreground-900 mb-2">及时更新</h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              第一时间跟进FIFA售票公告、政策变化和最新购票动态
            </p>
          </div>
          <div className="p-5 bg-background-50 rounded-lg border border-background-200">
            <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg mb-3">
              <i className="ri-user-heart-line text-accent-500 text-lg"></i>
            </div>
            <h3 className="text-base font-semibold text-foreground-900 mb-2">球迷视角</h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              从中国球迷的角度出发，提供中文购票指引和实用出行建议
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}